(function () {
  const CODE = 'WELCOME10';
  const el = document.getElementById('cartDiscountBadge');
  if (!el) return;

  const hasCookie = () =>
    document.cookie.split('; ').some(x => x.startsWith('welcome10_activated=1'));

  // default based on cookie
  el.hidden = !hasCookie();

  // try to confirm with cart.js too (if Shopify returns it)
  fetch('/cart.js', { credentials: 'same-origin' })
    .then(r => r.json())
    .then(cart => {
      const codes = Array.isArray(cart?.discount_codes) ? cart.discount_codes : [];
      const has = codes.some(d => String(d.code || '').toUpperCase() === CODE);

      // if cart confirms → show
      if (has) {
        el.hidden = false;
      } else {
        // if cart doesn't confirm, keep cookie behavior (don’t force hide)
        el.hidden = !hasCookie();
      }
    })
    .catch(() => {
      el.hidden = !hasCookie();
    });

})();